import { BUILD_TAG } from '../../../constants'
import { gnarClient } from '../../tracking/gnar'
import { Cookie, getCookie } from '../../utils/cookies'

export const clientType = 'cms'
export const clientVersion = isNaN(parseInt(BUILD_TAG, 10)) ? '1.0.' + BUILD_TAG : BUILD_TAG

export const getApplicationRequestHeaders = async () => {
  const containerId = await gnarClient.getContainerId()
  return {
    'X-CSRF-Token': getCookie(Cookie.CsrfToken)!,
    'X-Client-Type': clientType,
    'X-Client-Version': clientVersion,
    'X-Container-Id': containerId,
  } as const
}
